module.exports = __webpack_public_path__ + "static/media/Falconer.7011718a.jpg";